import { RouterProvider } from 'react-router';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import ThemeProvider from './providers/themeProvider';
import { store } from './store';
import router from './router';

import './App.css';

const Router = () => {
  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimaryBg: '#e6f0d7',
            colorPrimary: '#669137',
            colorPrimaryActive: '#19240f',
            colorPrimaryTextHover: '#19240f',
            colorLinkHover: '#19240f',
            colorLink: '#669137',
            colorText: 'rgba(0,0,0,.88)',
            colorTextSecondary: '#717c80',
            colorTextHeading: '#334423',
            colorTextBase: '#525356',
            colorTextLabel: '#78797d',
          },
          components: {
            Button: {
              primaryShadow: 'none',
            },
            Layout: {
              headerHeight: 64,
            },
            Menu: {
              itemBorderRadius: 0,
              itemBg: '#3d5727',
              itemColor: 'rgba(255,255,255,.65)',
              itemHoverColor: '#fff',
              itemHoverBg: '#4e6738',
              itemSelectedBg: '#4e6738',
              itemSelectedColor: '#88b359',
              darkItemBg: '#19240f',
              darkItemColor: 'rgba(255,255,255,.65)',
              darkItemHoverColor: '#fff',
              darkItemSelectedBg: '#669137',
              darkItemSelectedColor: '#fff',
              itemActiveBg: '#669137',
              colorBgSolidActive: '#669137',
              colorBgContainer: '#19240f',
            },
          },
        }}
      >
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </ConfigProvider>
    </Provider>
  );
};

export default Router;
